import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, styled } from '@mui/material';
import { SharedStyledDataGrid } from '@pages/Masterdata/StyledGridPageComponents';

export const StyledMeasurementVisualizationPage = styled(Box)(() => {
  return {
    height: '100vh',
    display: 'grid',
    gridTemplateColumns: '37.5rem auto',
  };
});

export const StyledManagementMenu = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRight: `1px solid ${tsoPqTheme.palette.stroke.color_primary_stroke_str_prim_accent}`,
    padding: `4.625rem 1.5rem 1.5rem 1.5rem`,
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_16,
  };
});

export const StyledManagementMenuHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
  };
});
export const StyledVisualisationSection = styled(Box)(() => {
  return {
    marginTop: `2.75rem`,
    padding: '2rem 1.5rem',
    backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
  };
});

export const StyledDataGrid = styled(SharedStyledDataGrid)(() => ({
  backgroundColor: '#fff',
  fontFamily: tsoPqTheme.typography.openSans,
  height: 'auto',

  '& .customBackgroundHeader': {
    backgroundColor: tsoPqTheme.palette.table.color_other_table_header,
    maxHeight: '2.3125rem',
  },
  '& .MuiDataGrid-cell': {
    alignContent: 'center',
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell--withRenderer': {
    userSelect: 'none',
  },
  '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
    opacity: 1,
    visibility: 'visible',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    zIndex: '999',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'pre-wrap',
    fontWeight: '700',
    fontSize: '0.875rem',
    fontFamily: tsoPqTheme.typography.openSans,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    letterSpacing: '0.007rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  },
  '& .MuiDataGrid-sortIcon': {
    visibility: 'visible',
    opacity: 1,
  },
  '& .selected-row': {
    backgroundColor: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_lt,
    '&:hover': {
      backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
    },
    '&.Mui-selected': {
      backgroundColor: `${tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_lt} !important`,
    },
  },
}));

export const StyledOrderNumber = styled(Box)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_primary_font_ft_prim_enabled,
    FormatSize: '0.875rem',
    lineHeight: '1.3125rem',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem',
    marginTop: '0.25rem',
  };
});

export const StyledEditIconWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    padding: '0.5rem',
    gap: '0.25rem',
  };
});

export const StyledHeaderTitle = styled(Box)(() => {
  return {
    fontWeight: '700',
    fontFamily: tsoPqTheme.typography.openSans,
    lineHeight: '1.685rem',
    fontSize: tsoPqTheme.typography.fontsize_title_list_section_small,
  };
});

export const StyledTitle = styled(Box)(() => {
  return {
    fontWeight: '700',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    lineHeight: '2.25rem',
    fontSize: tsoPqTheme.typography.fontsize_title_section_smaller,
  };
});

export const StyledChartWrapper = styled(Box)(() => {
  return {
    width: '100%',
    margin: '1.5rem 0',
  };
});

export const StyledChartSectionTitleSection = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledChartSectionTitleText = styled(Box)(() => {
  return {
    textAlign: 'center',
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: '1.5rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontWeight: '700',
    lineHeight: '2.125rem',
    fontStyle: 'normal',
    paddingBottom: '1rem',
  };
});

export const StyledChartSectionTitleActions = styled(Box)(() => {
  return {
    paddingBottom: '1rem',
  };
});
